import React, { Component, Fragment } from 'react';
import FormWithErrors from '../FormWithErrors.js';
import FontAwesomeIcon from '@fortawesome/react-fontawesome';

class UsersCreator extends Component
{
	constructor (props) {
		super(props);

		this.state = {
			firstname: "",
			lastname: "",
			email: "",
			isModalOpen: false,
			errors: {},
			isSaving: false
		};

		this.form = React.createRef();
		this.creationSubmit = this.creationSubmit.bind(this);
	}

	showErrors (field) {
		if (this.state.errors[field]) {
			return (
				<span className="help is-danger">{this.state.errors[field]}</span>
			);
		} else {
			return null;
		}
	}

	creationSubmit (e) {
		const that = this;

		e.preventDefault();

		this.setState({ isSaving: true });

		return new Promise((resolve, reject) => {
			const created = that.props.creator(that.state.firstname, that.state.lastname, that.state.email);
			if (created) {
				created
					.then(function () {
						that.setState({ errors: {},	 firstname: "", lastname: "", email: "", isModalOpen: false, isSaving: false });
					})
					.catch(function (response) {
						if ('response' in response && 'data' in response.response) {
							const data = response.response.data;
							if (data.errors) {
								that.setState({ errors: data.errors, isSaving: false });
							} else {
								throw response;
							}
						} else {
							throw response;
						}
					})
			}
    });
	}

	handleParamChange = (param) => (e) => {
		let state = this.state;
		state[param] = e.target.value;
		this.setState(state);
	}

	render () {
		return (
			<Fragment>
	 	  	<div className="page-section partial">
	 	  		<div className="title shadowless">
	 	  			<span className="title-content">
		 	  			Edit Users

		 	  			<input 
		 	  				type="button" 
		 	  				className="button is-primary is-gradient" 
		 	  				value="Add User" 
		 	  				onClick={() => this.setState({isModalOpen: true}) }
		 	  			/>
		 	  		</span>
	 	  		</div>
	 	  	</div>

		 	  <div className={(this.state.isModalOpen) ? 'modal is-active' : 'modal'}>
		 	  	<div className="modal-background"></div>
		 	  	<div className="modal-content">
		 	  		<div className="page-section partial">
		 	  			<div className="title">
		 	  				<span className="title-content">
		 	  					Invite a User
		 	  				</span>
		 	  			</div>
		 	  			<form ref={this.form} key="users.creator">
			 	  			<div className="content">
					      	<div className="field is-horizontal">
					      		<div className="field-body">
					      			<div className="field">
									      <p className="control is-expanded has-icons-left">
									        <input 
									        	className="input" 
									        	type="text" 
									        	placeholder="Firstname (optional)" 
									        	onChange={this.handleParamChange('firstname')} 
									        	value={this.state.firstname}
									        />
									        <span className="icon is-small is-left">
									        	<FontAwesomeIcon icon="user" />
									        </span>
									        {this.showErrors('firstname')}
									      </p>
					      			</div>
					      			<div className="field">
									      <p className="control is-expanded has-icons-left">
									        <input 
									        	className="input" 
									        	type="text" 
									        	placeholder="Lastname (optional)" 
									        	onChange={this.handleParamChange('lastname')}
									        	value={this.state.lastname}
									        />
									        <span className="icon is-small is-left">
									        	<FontAwesomeIcon icon="user" />
									        </span>
									        {this.showErrors('lastname')}
									      </p>
					      			</div>
					      		</div>
					      	</div>
					      	<div className="field is-horizontal">
					      		<div className="field-body">
					      			<div className="field">
									      <p className="control is-expanded has-icons-left">
									        <input 
									        	required 
									        	className="input" 
									        	type="email" 
									        	placeholder="E-Mail Address" 
									        	onChange={this.handleParamChange('email')} 
									        	value={this.state.email}
									        />
									        <span className="icon is-small is-left">
									          <FontAwesomeIcon icon="envelope" />
									        </span>
									        {this.showErrors('email')}
									      </p>
					      			</div>
					      		</div>
					      	</div>
			 	  			</div>
			 	  			<div className="bottom">
						      <div className="level">
						        <div className="level-left">
						        	<button 
						        		noValidate
						        		type="button"
						        		className="button is-primary is-outlined" 
						        		onClick={() => this.setState({
						        			isModalOpen: false,
						        			firstname: "",
						        			lastname: "",
						        			email: "",
						        			errors: {}
						        		}) }
						        	>Cancel</button>
						        </div>
						        <div className="level-right">
						          <span className="level-item">
						            <button
						            	noValidate
						            	disabled={this.state.isSaving || (this.form.current && !this.form.current.checkValidity())} 
						            	onClick={this.creationSubmit}
						            	className={this.state.isSaving ? 'button is-primary is-loading' : 'button is-primary'} 
						            >
						            	Invite User
						            </button>
						          </span>
						        </div>
						      </div>
			 	  			</div>
		 	  			</form>
		 	  		</div>
		 	  	</div>
		 	  </div>
	    </Fragment>
		);
	}
}

export default UsersCreator;


// WEBPACK FOOTER //
// ./src/Components/Users/UsersCreator.js